import {
    type Organization,
    type OrganizationDetails,
    OrganizationStatus,
} from "src/types/organization";
import { type Pos, PosStatus } from "src/types/pos";
import { type PosGroup, PosGroupStatus } from "src/types/posGroup";
import { type User, type UserRelationIds, UserStatus } from "src/types/user";

export const isOrganizationEnabled = (organization: Organization): boolean =>
    organization.status === OrganizationStatus.activated ||
    organization.status === OrganizationStatus.demo ||
    organization.status === OrganizationStatus.test;

export const isUserEnabled = (user: User): boolean =>
    isOrganizationEnabled(user.organization) && user.status === UserStatus.activated;

export const isPosEnabled = (pos: Pos): boolean => pos.status === PosStatus.activated;

export const isPosGroupEnabled = (posGroup: PosGroup): boolean =>
    isOrganizationEnabled(posGroup.organization) && posGroup.status === PosGroupStatus.activated;

export const filterOrganizationsToDisplay = (
    organizations: OrganizationDetails[],
    disabled = false
): OrganizationDetails[] => {
    if (disabled) {
        return organizations;
    }
    return organizations.filter((e) => isOrganizationEnabled(e));
};

export const filterUsersToDisplayWithCount = (
    data: {
        users: UserRelationIds[];
    },
    disabled = false
): UserRelationIds[] => {
    if (disabled) {
        return data.users;
    }
    return data.users.filter(
        (e) => isOrganizationEnabled(e.organization) && e.status === UserStatus.activated
    );
};

export const filterUsersToDisplay = (
    data: {
        users: UserRelationIds[];
        count: number;
    },
    disabled = false
): any => {
    if (disabled) {
        return {
            users: data.users,
            count: data.count,
        };
    }
    return {
        users: data.users.filter(
            (e) => isOrganizationEnabled(e.organization) && e.status === UserStatus.activated
        ),
        count: data.count,
    };
};

export const filterPossToDisplay = (poss: Pos[], disabled = false): Pos[] => {
    if (disabled) {
        return poss;
    }
    return poss.filter(
        (e) => isOrganizationEnabled(e.organization) && e.status === PosStatus.activated
    );
};

export const filterPosGroupsToDisplay = (posGroups: PosGroup[], disabled = false): PosGroup[] => {
    if (disabled) {
        return posGroups;
    }

    return posGroups.filter(
        (e) => isOrganizationEnabled(e.organization) && e.status === PosGroupStatus.activated
    );
};
